const firebaseConfig = {
    apiKey: "AIzaSyB3tddEePUmnQvcHmhqyNYAymd8HAHT7BY",
    authDomain: "ema-john-ecommerce.firebaseapp.com",
    databaseURL: "https://ema-john-ecommerce.firebaseio.com",
    projectId: "ema-john-ecommerce",
    storageBucket: "ema-john-ecommerce.appspot.com",
    messagingSenderId: "560020907084",
    appId: "1:560020907084:web:7f258eb259d055424100e9"
  };

  export default firebaseConfig;